import type React from 'react';
import { ITEM_TYPES } from '../constants/index.js';
import type { DSLeftNavigationT } from '../react-desc-prop-types.js';
import { ItemControlledDrilldown } from './ItemControlledDrilldown/index.js';
import { ItemHeader } from './ItemHeader/index.js';
import { ItemLink } from './ItemLink/index.js';
import { ItemSection } from './ItemSection/index.js';
import { ItemSeparator } from './ItemSeparator/index.js';
import { ItemSkeleton } from './ItemSkeleton/index.js';
import { ItemSubmenu } from './ItemSubmenu/index.js';
import { ItemTextLabel } from './ItemTextLabel/index.js';
import { ItemUncontrolledDrilldown } from './ItemUncontrolledDrilldown/index.js';
import { ItemWithDate } from './ItemWithDate/index.js';

export * from './ItemControlledDrilldown/index.js';
export * from './ItemHeader/index.js';
export * from './ItemLink/index.js';
export * from './ItemSection/index.js';
export * from './ItemSeparator/index.js';
export * from './ItemSkeleton/index.js';
export * from './ItemSubmenu/index.js';
export * from './ItemTextLabel/index.js';
export * from './ItemUncontrolledDrilldown/index.js';
export * from './ItemWithDate/index.js';

const {
  LEFT_NAV_ITEM_CONTROLLED_DRILLDOWN,
  LEFT_NAV_ITEM_UNCONTROLLED_DRILLDOWN,
  LEFT_NAV_ITEM_HEADER,
  LEFT_NAV_ITEM_LINK,
  LEFT_NAV_ITEM_SECTION,
  LEFT_NAV_ITEM_SEPARATOR,
  LEFT_NAV_ITEM_SKELETON,
  LEFT_NAV_ITEM_SUBMENU,
  LEFT_NAV_ITEM_TEXT_LABEL,
  LEFT_NAV_ITEM_WITH_DATE,
} = ITEM_TYPES;

export const outOfTheBoxComponents: Record<string, React.ComponentType<DSLeftNavigationT.ComponentProps>> = {
  [LEFT_NAV_ITEM_CONTROLLED_DRILLDOWN]: ItemControlledDrilldown,
  [LEFT_NAV_ITEM_UNCONTROLLED_DRILLDOWN]: ItemUncontrolledDrilldown,
  [LEFT_NAV_ITEM_HEADER]: ItemHeader,
  [LEFT_NAV_ITEM_LINK]: ItemLink,
  [LEFT_NAV_ITEM_SECTION]: ItemSection,
  [LEFT_NAV_ITEM_SEPARATOR]: ItemSeparator,
  [LEFT_NAV_ITEM_SKELETON]: ItemSkeleton,
  [LEFT_NAV_ITEM_SUBMENU]: ItemSubmenu,
  [LEFT_NAV_ITEM_TEXT_LABEL]: ItemTextLabel,
  [LEFT_NAV_ITEM_WITH_DATE]: ItemWithDate,
};
